/**
 * Environment-based configuration loader
 * Automatically selects the correct configuration based on REACT_APP_ENV or NODE_ENV
 */

const env = process.env.REACT_APP_ENV || process.env.NODE_ENV;
const isA11yTest = process.env.REACT_APP_A11Y_TEST === 'true';

// Dynamic import based on environment
let config;
if (isA11yTest) {
  // Use test config for accessibility testing - bypasses auth, uses mock API
  config = require('./config.a11ytest');
} else if (env === 'production') {
  config = require('./config.prod');
} else if (env === 'uat') {
    config = require('./config.uat');
} else if (env === 'devnonprod') {
    config = require('./config.devnonprod');
} else {
    config = require('./config.local');
}

export const msalConfig = config.msalConfig;
export const msalConfigCorporate = config.msalConfigCorporate;
export const loginRequest = config.loginRequest;
export const loginRequestCorporate = config.loginRequestCorporate;
export const getLoginRequest = config.getLoginRequest;
export const apiConfig = config.apiConfig;
export const appConfig = config.appConfig;
export const isTestMode = config.isTestMode ?? false;

// Authentication provider type
export type AuthProvider = 'b2c' | 'corporate';

// Helper to get/set the selected auth provider
const AUTH_PROVIDER_KEY = 'auth_provider';

export const getAuthProvider = (): AuthProvider => {
  const stored = sessionStorage.getItem(AUTH_PROVIDER_KEY);
  return (stored as AuthProvider) || 'b2c';
};

export const setAuthProvider = (provider: AuthProvider): void => {
  sessionStorage.setItem(AUTH_PROVIDER_KEY, provider);
};

export const clearAuthProvider = (): void => {
  sessionStorage.removeItem(AUTH_PROVIDER_KEY);
};

// Export environment info for debugging
export const environment = {
    isDevelopment: env === 'development',
    isDevNonProd: env === 'devnonprod',
    isUAT: env === 'uat',
    isProduction: env === 'production',
    env: env,
};
